module.exports = __webpack_public_path__ + "img/BD-F.2af43b8a.png";